import React, { useState } from "react";
import { Box, MenuItem, FormControl, Select, InputLabel } from "@mui/material";

import ExecSummaryChart from "../../Components/Charts/ExecSummaryChart";
import HotspotHeatmapChart from "../../Components/Charts/HotspotHeatmapChart";
import ModelConfidenceChart from "../../Components/Charts/ModelConfidenceChart";
import HighValueChart from "../../Components/Charts/HighValueChart";
import TrafficInsightsChart from "../../Components/Charts/TrafficInsightsChart";

const charts = {
  exec_summary: <ExecSummaryChart />,
  hotspot: <HotspotHeatmapChart />,
  model_audit: <ModelConfidenceChart />,
  high_value: <HighValueChart />,
  traffic: <TrafficInsightsChart />
};

const VisualizationsDashboard = () => {
  const [view, setView] = useState("exec_summary");

  return (
    <Box sx={{ p: 1, display: "flex", flexDirection: "column", width: "100%" }}>
      <Box sx={{ maxWidth: 400, mb: 4 }}>
        <FormControl fullWidth>
          <InputLabel id="visualization-select-label">Select Visualization Dashboard</InputLabel>
          <Select
            labelId="visualization-select-label"
            value={view}
            label="Select Visualization Dashboard"
            onChange={(e) => setView(e.target.value)}
          >
            <MenuItem value="exec_summary">Executive Summary (Lost Items & Trends)</MenuItem>
            <MenuItem value="hotspot">Hotspot & Risk Mapping Heatmap</MenuItem>
            <MenuItem value="model_audit">Model Accuracy & Confidence Audit</MenuItem>
            <MenuItem value="high_value">High-Value Target & Item Analysis</MenuItem>
            <MenuItem value="traffic">Store Traffic & Regional Benchmark Insights</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Render selected view */}
      <Box sx={{ animation: "fadeIn 0.5s ease-in-out", width: "100%" }}>
        {charts[view] ? React.cloneElement(charts[view]) : null}
      </Box>
    </Box>
  );
};

export default VisualizationsDashboard;
